import { BlockType } from "../../types/block/type";
import { AccessRole } from "../../types/userCalendars/enum";
import { UserCalendarType } from "../../types/userCalendars/type";

/**
 * 이벤트가 수정 가능한지 여부를 확인하는 유틸리티 함수
 *
 * @param block - 확인할 블록 객체
 * @returns boolean - 블록 수정 가능 여부
 *
 * @description
 * 블록이 수정 가능한 조건:
 * 1. 캘린더의 accessRole이 WRITER 또는 OWNER인 경우
 * 2. meetWith 블록이 아닌 경우
 */
export const isEditableBlock = (block: BlockType): boolean => {
  const isEditableBlock =
    block?.calendar?.accessRole === AccessRole.WRITER ||
    block?.calendar?.accessRole === AccessRole.OWNER;

  return !block.isMeetWith && isEditableBlock;
};

/**
 * 구글 프라이머리 캘린더인지 확인하는 함수
 * @param calendar - 확인할 캘린더 객체
 * @param isEditableBlock - 수정 가능한 블록인지 여부
 * @returns boolean - 구글 그룹 캘린더인지 여부
 */
export const getIsGooglePrimaryCalendar = ({ calendar }: { calendar: UserCalendarType }) => {
  const getIsGooglePrimaryCalendar = !calendar.gcalId?.includes("@group.calendar.google.com");
  return getIsGooglePrimaryCalendar;
};

/**
 * 블록의 start 또는 end가 null인지 확인하는 유틸리티 함수
 *
 * @param block - 확인할 블록 객체
 * @returns boolean - start 또는 end가 null인 경우 true, 그렇지 않으면 false
 */
export const hasNoStartOrEnd = (block: BlockType): boolean => {
  return block.start === null || block.end === null;
};
